import { useCallback, useState } from "react";
import { motion } from "framer-motion";
import { DotLottieReact } from "@lottiefiles/dotlottie-react";

import rotateCircleShineAnimation from "@/assets/lottie/rotate-circle-shine.lottie";
import GameEndMessageModal from "@/components/screens/GameEndSequence/components/GameEndMessageModal";

type Props = {
  onComplete: () => void;
  /** Duration of the modal exit animation in ms */
  modalExitDuration?: number;
  /** Duration of the lottie fade-out in ms */
  lottieExitDuration?: number;
  /** Delay between modal exit start and lottie fade-out start in ms */
  exitStagger?: number;
};

const GameEndMessageStep = ({
  onComplete,
  modalExitDuration = 200,
  lottieExitDuration = 300,
  exitStagger = 100,
}: Props) => {
  const [dismissing, setDismissing] = useState(false);

  const handleDismiss = useCallback(() => {
    setDismissing(true);

    const totalDuration = Math.max(modalExitDuration, exitStagger + lottieExitDuration);

    setTimeout(() => {
      onComplete();
    }, totalDuration);
  }, [onComplete, modalExitDuration, lottieExitDuration, exitStagger]);

  return (
      <div className="absolute inset-0 size-full">
        {/* Background looping lottie */}
        <motion.div
            className="absolute inset-0"
            animate={{ opacity: dismissing ? 0 : 1 }}
            transition={{
              duration: lottieExitDuration / 1000,
              delay: dismissing ? exitStagger / 1000 : 0,
              ease: "easeInOut",
            }}
        >
          <DotLottieReact
              src={rotateCircleShineAnimation}
              autoplay
              loop
              layout={{ fit: "cover" }}
          />
        </motion.div>

        {/* Modal on top */}
        <GameEndMessageModal exiting={dismissing} onDismiss={handleDismiss} />
      </div>
  );
};

export default GameEndMessageStep;